import { Module } from "vuex";

import { EncountersAPI } from "@/api/encounters";
import { Encounter } from "@/store/modules/encounters/interfaces/Encounter";
import { RootState } from "@/types";
import { EncounterQueryFilterDto } from "@/types/EncounterQueryFilter";

interface EncountersState {
  encounters: Encounter[];
  currentEncounter: Encounter | null;
}

export const encounters: Module<EncountersState, RootState> = {
  namespaced: true,
  state: {
    encounters: [],
    currentEncounter: null,
  },
  mutations: {
    setEncounters(state, payload) {
      state.encounters = payload;
    },
    setCurrentEncounter(state, payload) {
      state.currentEncounter = payload;
    },
  },
  actions: {
    async getAllEncounters({ commit }, query?: EncounterQueryFilterDto) {
      const encounters = await EncountersAPI.getAll(query);
      commit("setEncounters", encounters);
    },
    async getCurrentEncounterById({ commit }, encounterId) {
      const encounter = await EncountersAPI.getById(encounterId);
      commit("setCurrentEncounter", encounter);
    },
  },
  getters: {
    encounters(state) {
      return state.encounters;
    },
    plannedEncounters(state) {
      const now = new Date();
      return state.encounters.filter((e) => e.status === "planned" && new Date(e.end) >= now);
    },
    currentEncounter(state) {
      return state.currentEncounter;
    },
  },
};
